import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { useMatchMedia } from '../../mq/esm';
import { BaseUniversalDateInput } from './components/base-universal-date-input/Component.js';
import 'react-merge-refs';
import '@maskito/react';
import 'classnames';
import 'date-fns/endOfDay';
import 'date-fns/startOfDay';
import './consts.js';
import 'date-fns/clamp';
import 'date-fns/getDaysInMonth';
import 'date-fns/isValid';
import 'date-fns/differenceInDays';
import 'date-fns/format';
import 'date-fns/isSameDay';
import 'date-fns/parse';
import './components/date-input/Component.js';
import '../../input/esm';
import '../../popover/esm';
import '../../shared/esm';
import '@alfalab/icons-glyph/CalendarMIcon';
import './index.module-bbbccbbb.js';
import './components/date-range-input/Component.js';
import 'date-fns/startOfMonth';
import './components/time-input/Component.js';
import './mask/index.js';
import './mask/plugins.js';
import './mask/utils.js';
import './mask/postprocessors.js';
import './mask/preprocessors.js';
import './utils/index.js';

var UniversalDateInput = forwardRef(function (_a, ref) {
    var _b = _a.breakpoint, breakpoint = _b === void 0 ? 1024 : _b, defaultMatchMediaValue = _a.defaultMatchMediaValue, view = _a.view, restProps = __rest(_a, ["breakpoint", "defaultMatchMediaValue", "view"]);
    var isDesktop = useMatchMedia("(min-width: ".concat(breakpoint, "px)"), defaultMatchMediaValue)[0];
    return (React.createElement(BaseUniversalDateInput, __assign({}, restProps, { ref: ref, view: view, breakpoint: breakpoint, defaultMatchMediaValue: defaultMatchMediaValue, platform: isDesktop ? 'desktop' : 'mobile' })));
});

export { UniversalDateInput };
